/* 🤖 this file was generated by script */
export const wsolidiconCheckCircleBroken = {
  name: 'check_circle_broken',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M10 .83a9.17 9.17 0 1 0 8.5 5.75c-.17-.44-.26-.66-.47-.8a1 1 0 0 0-.63-.13c-.25.04-.44.24-.83.63l-5.98 5.98a.83.83 0 0 1-1.18 0l-2.5-2.5A.83.83 0 0 1 8.1 8.6l1.91 1.9 5.81-5.81c.32-.32.47-.47.53-.68a1 1 0 0 0-.02-.55c-.08-.2-.23-.32-.53-.56A9 9 0 0 0 10 .83"/></svg>`,
  iconStyle: 'solid',
};
